<template>
    <div>
        <h2 v-html="task.question"></h2>
        <div class="row">
            <div class="col-12">
                <b>
                    Az Ön által meghatározott vélemény:
                </b>
                <div v-html="userTask.solution.opinion"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        userTask: {
            type: Object,
            required: true,
        },
        task: {
            type: Object,
            required: true,
        },
    },
}
</script>
